import { useEffect, useRef, useState } from 'react';

export interface ThemePickerCardMenuAction {
  label: string;
  onSelect: () => void;
}

interface Props {
  readonly actions: ThemePickerCardMenuAction[];
}

// "…" affordance rendered next to each theme picker card. Presets get a
// single "Kopioi" action; custom themes get Muokkaa / Kopioi / Poista.
export function ThemePickerCardMenu({ actions }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div className="theme-picker-card-menu" ref={ref}>
      <button
        type="button"
        aria-label="Lisää toimintoja"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        …
      </button>
      {open ? (
        <div role="menu" className="theme-picker-card-menu__list">
          {actions.map((a) => (
            <button
              key={a.label}
              type="button"
              role="menuitem"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                a.onSelect();
              }}
            >
              {a.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
